import {GetServiceCaseOrdersApiResponse} from '@dms/api/workshop';

interface OrderWithMarginUnderMinimum {
  number: string;
  serviceOrderId: string;
}

export function getOrdersWithMarginUnderMinimum(
  serviceCaseOrders: GetServiceCaseOrdersApiResponse | undefined
): OrderWithMarginUnderMinimum[] {
  return (
    serviceCaseOrders
      ?.filter((order) => order.hasMarginUnderMinimum)
      .map((order) => ({
        number: order.number,
        serviceOrderId: order.serviceOrderId,
      })) ?? []
  );
}
